import { FC, Fragment } from 'react';
import { Order } from 'types/graphql';
import { withMemo } from 'utils/withMemo';
import { IGroupOrdersProps } from './GroupOrdersComponent.types';
import { useGroupOrdersContext } from './useGroupOrdersContext';
import { ShiftCardSkeleton } from 'components/ShiftCardSkeleton/ShiftCardSkeleton';

export const GroupOrdersComponent: FC<IGroupOrdersProps> = withMemo((props: IGroupOrdersProps) => {
  const { order, fetch } = useGroupOrdersContext<Required<Order>>(props);
  if (!order?.id) return <Fragment />;
  return <ShiftCardSkeleton order={order} fetch={fetch} />;
});
